import { PERMISSIONS } from "@/services/permission"

export default [
  {
    path: "/customer/list",
    name: "CustomerOverview",
    component: () => import("@/views/customer/CustomerOverview"),
    meta: {
      title: "nav.customer.overview",
      requiresAuth: true,
      requiresAllPermissions: [PERMISSIONS.VIEW_CUSTOMER_GENERAL],
    },
  },
  {
    path: "/customer/create",
    name: "CustomerCreate",
    component: () => import("@/views/customer/CustomerCreate"),
    meta: {
      title: "customer.create.title",
      requiresAuth: true,
      requiresAllPermissions: [PERMISSIONS.EDIT_CUSTOMER_GENERAL],
    },
  },
  {
    path: "/customer/:customerId",
    name: "CustomerDetail",
    props: true,
    component: () => import("@/views/customer/CustomerDetail"),
    meta: {
      title: "nav.customer.overview",
      requiresAuth: true,
      requiresPermissions: [
        PERMISSIONS.VIEW_CUSTOMER_GENERAL,
        PERMISSIONS.VIEW_CUSTOMER_CONTACT,
        PERMISSIONS.VIEW_CUSTOMER_MACHINE,
        PERMISSIONS.VIEW_CUSTOMER_MATERIAL,
        PERMISSIONS.VIEW_CUSTOMER_ADDITIONAL_EFFORT,
        PERMISSIONS.VIEW_CUSTOMER_FILE,
        PERMISSIONS.VIEW_CUSTOMER_USERPOSITION,
        PERMISSIONS.VIEW_CUSTOMER_SETTINGS,
      ],
    },
  },
]
